module.exports = __webpack_public_path__ + "static/01-0ab2f5d65b2bd9b3fd32fa7790e83a46.jpg";